/*
 * Bundle Variation JS
 * Handles top/pants pair selection and pricing for bundle products.
 * Manages ATC button state based on variant availability.
 */

// Prevent stock ProductRerender from overwriting the bundle ATC button.
// On bundle pages, the stock VariantPicker dispatches product:rerender events
// which cause ProductRerender to replace <buy-buttons> with server-rendered HTML
// that always says "Choose options" (since the bundle product has no selected variant).
// Bundle pages manage their own ATC state via this script, so we block that rerender.
document.addEventListener('product:rerender', function(e) {
  if (document.querySelector('[data-bundle-top-container]')) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}, true);

function _bundleFormatMoney(cents) {
  var fmt = window.themeVariables?.settings?.moneyFormat || "${{amount}}";
  var d = parseFloat(cents) || 0;
  var amt = d.toFixed(2), noD = Math.floor(d).toString(), comma = amt.replace(".", ",");
  return fmt
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noD)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noD)
    .replace(/\{\{\s*amount\s*\}\}/, amt);
}

document.addEventListener("DOMContentLoaded", function () {
  try {
    // --- ATC button state ---
    function e(enabled) {
      var btn = document.querySelector('buy-buttons button[type="submit"]');
      var bc = btn ? btn.querySelector("button-content") : null;
      if (btn) btn.disabled = !enabled;
      if (bc) {
        bc.textContent = enabled ? "Add to bag" : "Sold out";
        bc.setAttribute("up-text", enabled ? "Add to bag" : "Sold out");
      }
    }

    // --- Price totals ---
    function t() {
      var topPrice = n.querySelector("[data-bundle-top-price]"),
        pantsPrice = o.querySelector("[data-bundle-pants-price]"),
        topCompare = n.querySelector("[data-bundle-top-compare-price]"),
        pantsCompare = o.querySelector("[data-bundle-pants-compare-price]"),
        totalEl = document.querySelector("[data-bundle-total-price]"),
        totalCompareEl = document.querySelector("[data-bundle-total-compare-price]");

      var parse = function (el, fallback) {
        if (!el || !el.textContent.trim()) {
          if (fallback && fallback.textContent.trim()) {
            var v = fallback.textContent.replace(/[^\d.]/g, "");
            return parseFloat(v) || 0;
          }
          return 0;
        }
        var v = el.textContent.replace(/[^\d.]/g, "");
        return parseFloat(v) || 0;
      };

      var total = parse(topPrice) + parse(pantsPrice),
        compareTotal = parse(topCompare, topPrice) + parse(pantsCompare, pantsPrice);

      if (totalEl) totalEl.textContent = _bundleFormatMoney(total);
      if (totalCompareEl) {
        if (compareTotal > 0 && compareTotal !== total) {
          totalCompareEl.textContent = _bundleFormatMoney(compareTotal);
          totalCompareEl.style.display = "block";
        } else {
          totalCompareEl.textContent = "";
          totalCompareEl.style.display = "none";
        }
      }
    }

    // --- Validation ---
    function a() {
      // Auto-fix: if a selected swatch is disabled (sold out), shift to first available
      function _fix(container, nameEl) {
        if (!container) return;
        var sel = container.querySelector(".block-swatch.is-selected.is-disabled");
        if (sel) {
          sel.classList.remove("is-selected");
          var av = container.querySelector(".block-swatch:not(.is-disabled)");
          if (av) {
            av.classList.add("is-selected");
            if (nameEl) nameEl.textContent = av.textContent.trim();
          } else {
            if (nameEl) nameEl.textContent = "";
          }
        }
      }

      _fix(d, n.querySelector("[data-bundle-top-size-name]"));
      _fix(S, o?.querySelector("[data-bundle-pants-size-name]"));
      var pantsLenEl = o?.querySelector("[data-bundle-pants-lengths]");
      if (pantsLenEl && pantsLenEl.children.length)
        _fix(pantsLenEl, o?.querySelector("[data-bundle-pants-length-name]"));

      var topSize = n.querySelector("[data-bundle-top-size-name]")?.textContent?.trim(),
        pantsSize = o?.querySelector("[data-bundle-pants-size-name]")?.textContent?.trim(),
        pantsLengths = o?.querySelector("[data-bundle-pants-lengths]"),
        pantsLength = o?.querySelector("[data-bundle-pants-length-name]")?.textContent?.trim(),
        hasLengths = !(!pantsLengths || !pantsLengths.children.length),
        topSwOk = !d || !!d.querySelector(".block-swatch.is-selected:not(.is-disabled)"),
        pantsSwOk = !S || !!S.querySelector(".block-swatch.is-selected:not(.is-disabled)"),
        lenSwOk = !hasLengths || !!pantsLengths.querySelector(".block-swatch.is-selected:not(.is-disabled)");

      e(topSize && pantsSize && (!hasLengths || pantsLength) && topSwOk && pantsSwOk && lenSwOk);
    }

    // --- Embroidery reset on swatch change ---
    function s() {
      var ec = document.getElementById("embroidery-container");
      if (ec && ec.style.display !== "none" && ec.offsetParent !== null) {
        var db = document.getElementById("delete-embroidery");
        if (db) db.click();
      }
    }

    // --- DOM refs ---
    var n = document.querySelector("[data-bundle-top-container]");
    if (!n) return;

    var o = document.querySelector("[data-bundle-pants-container]"),
      l = n.querySelector("[data-bundle-top-image]"),
      c = n.querySelector("[data-bundle-top-link]"),
      r = n.querySelector("[data-bundle-top-title]"),
      i = n.querySelector("[data-bundle-top-color-name]"),
      d = n.querySelector("[data-bundle-top-sizes]"),
      u = (n.querySelector("[data-bundle-top-lengths]"), n.querySelector("[data-bundle-top-price]")),
      p = n.querySelector("[data-bundle-top-compare-price]"),
      m = o?.querySelector("[data-bundle-pants-image]"),
      b = o?.querySelector("[data-bundle-pants-link]"),
      h = o?.querySelector("[data-bundle-pants-title]"),
      y = o?.querySelector("[data-bundle-pants-color-name]"),
      S = o?.querySelector("[data-bundle-pants-sizes]"),
      f = o?.querySelector("[data-bundle-pants-lengths]"),
      q = o?.querySelector("[data-bundle-pants-price]"),
      v = o?.querySelector("[data-bundle-pants-compare-price]");

    // --- Top color swatch handlers ---
    var x = document.querySelectorAll(".bundle-top-color-swatch__container .color-swatch");
    x.forEach(function (swatch) {
      swatch.addEventListener("click", function (ev) {
        ev.preventDefault();
        s();
        document.querySelectorAll(".bundle-top-color-swatch__container .color-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
        swatch.classList.add("is-selected");
        if (l && swatch.dataset.image) l.src = swatch.dataset.image;
        if (c) c.href = swatch.getAttribute("href");
        if (r && swatch.dataset.title) r.textContent = swatch.dataset.title;
        if (i && swatch.dataset.colorName) i.textContent = swatch.dataset.colorName;
        if (u && swatch.dataset.price) u.textContent = swatch.dataset.price;
        if (p) {
          p.innerHTML = swatch.dataset.comparePrice
            ? '<span class="text-subdued line-through">' + swatch.dataset.comparePrice + "</span>"
            : "";
        }
        t();

        var prevSize = d.querySelector(".block-swatch.is-selected")?.textContent?.trim();
        if (d && swatch.dataset.sizes) {
          var sizes = JSON.parse(swatch.dataset.sizes);
          d.innerHTML = "";
          var firstEl = null;
          sizes.forEach(function (sz) {
            var label = document.createElement("label");
            label.className = "block-swatch";
            label.textContent = sz.value;
            label.addEventListener("click", function () {
              d.querySelectorAll(".block-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
              label.classList.add("is-selected");
              n.querySelector("[data-bundle-top-size-name]").textContent = sz.value;
              a();
            });
            if (!firstEl) firstEl = label;
            d.appendChild(label);
          });

          var matchEl = Array.from(d.children).find(function (el) { return el.textContent.trim() === prevSize; });
          if (matchEl) {
            matchEl.classList.add("is-selected");
            n.querySelector("[data-bundle-top-size-name]").textContent = matchEl.textContent.trim();
          } else if (firstEl) {
            firstEl.classList.add("is-selected");
            n.querySelector("[data-bundle-top-size-name]").textContent = firstEl.textContent.trim();
          }

          var variants = JSON.parse(swatch.dataset.variants || "[]");
          d.querySelectorAll(".block-swatch").forEach(function (el) {
            var val = el.textContent.trim(),
              avail = variants.some(function (v) { return v.option2 === val && v.available; });
            el.classList.remove("is-disabled");
            if (!avail) el.classList.add("is-disabled");
          });
        }
        a();

        (function syncEmbroideryPopupImage() {
          var href = swatch.getAttribute('href') || '';
          var match = href.match(/\/products\/([^/?#]+)/);
          if (!match) return;
          fetch('/products/' + match[1] + '.js')
            .then(function(res) { return res.json(); })
            .then(function(prod) {
              var popup = (prod.media || []).find(function(m) {
                return (m.alt || '').toLowerCase().includes('popup:');
              });
              if (!popup) return;
              var src = popup.src.startsWith('http') ? popup.src : 'https:' + popup.src;
              document.querySelectorAll('.embroidery-image').forEach(function(el) {
                el.src = src;
                el.alt = popup.alt || '';
              });
            })
            .catch(function() {});
        })();

      });
    });



    // --- Pants color swatch handlers ---
    var C = document.querySelectorAll(".bundle-pants-color-swatch__container .color-swatch");
    C.forEach(function (swatch) {
      swatch.addEventListener("click", function (ev) {
        ev.preventDefault();
        s();
        document.querySelectorAll(".bundle-pants-color-swatch__container .color-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
        swatch.classList.add("is-selected");
        if (m && swatch.dataset.image) m.src = swatch.dataset.image;
        if (b) b.href = swatch.getAttribute("href");
        if (h && swatch.dataset.title) h.textContent = swatch.dataset.title;
        if (y && swatch.dataset.colorName) y.textContent = swatch.dataset.colorName;
        if (q && swatch.dataset.price) q.textContent = swatch.dataset.price;
        if (v) {
          v.innerHTML = swatch.dataset.comparePrice
            ? '<span class="text-subdued line-through">' + swatch.dataset.comparePrice + "</span>"
            : "";
        }
        t();

        var prevSize = S.querySelector(".block-swatch.is-selected")?.textContent?.trim(),
          prevLen = f?.querySelector(".block-swatch.is-selected")?.textContent?.trim();

        if (S && swatch.dataset.sizes) {
          var sizes = JSON.parse(swatch.dataset.sizes);
          S.innerHTML = "";
          var firstEl = null;
          sizes.forEach(function (sz) {
            var label = document.createElement("label");
            label.className = "block-swatch";
            label.textContent = sz.value;
            label.addEventListener("click", function () {
              S.querySelectorAll(".block-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
              label.classList.add("is-selected");
              o.querySelector("[data-bundle-pants-size-name]").textContent = sz.value;
              a();
            });
            if (!firstEl) firstEl = label;
            S.appendChild(label);
          });

          var matchEl = Array.from(S.children).find(function (el) {
            return el.textContent.trim() === prevSize && !el.classList.contains("is-disabled");
          });
          if (matchEl) {
            matchEl.classList.add("is-selected");
            o.querySelector("[data-bundle-pants-size-name]").textContent = matchEl.textContent.trim();
          } else if (firstEl) {
            firstEl.classList.add("is-selected");
            o.querySelector("[data-bundle-pants-size-name]").textContent = firstEl.textContent.trim();
          }
        }

        // Pants without lengths
        if (!f || !swatch.dataset.lengths) {
          var variants = JSON.parse(swatch.dataset.variants || "[]");
          S.querySelectorAll(".block-swatch").forEach(function (el) {
            var val = el.textContent.trim(),
              avail = variants.some(function (v) { return v.option2 === val && v.available; });
            el.classList.remove("is-disabled");
            if (!avail) {
              el.classList.add("is-disabled");
              if (el.classList.contains("is-selected")) e(false);
            }
          });
          a();
        }

        // Pants with lengths
        if (f && swatch.dataset.lengths) {
          var lengths = JSON.parse(swatch.dataset.lengths);
          f.innerHTML = "";
          var firstLen = null;
          lengths.forEach(function (len) {
            var label = document.createElement("label");
            label.className = "block-swatch";
            label.textContent = len.value;
            if ("false" === len.available) {
              label.classList.add("is-disabled");
            } else {
              label.addEventListener("click", function () {
                f.querySelectorAll(".block-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
                label.classList.add("is-selected");
                o.querySelector("[data-bundle-pants-length-name]").textContent = len.value;
                var selLen = len.value,
                  pantsVariants = JSON.parse(swatch.dataset.variants || "[]");
                S.querySelectorAll(".block-swatch").forEach(function (el) {
                  var val = el.textContent.trim(),
                    avail = pantsVariants.some(function (v) { return v.option2 === selLen && v.option3 === val && v.available; });
                  el.classList.remove("is-disabled");
                  if (!avail) {
                    el.classList.add("is-disabled");
                    if (el.classList.contains("is-selected")) e(false);
                  }
                });
                a();
              });
              if (!firstLen) firstLen = label;
            }
            f.appendChild(label);
          });

          var matchLen = Array.from(f.children).find(function (el) {
            return el.textContent.trim() === prevLen && !el.classList.contains("is-disabled");
          });
          if (matchLen) {
            matchLen.classList.add("is-selected");
            o.querySelector("[data-bundle-pants-length-name]").textContent = matchLen.textContent.trim();
          } else if (firstLen) {
            firstLen.classList.add("is-selected");
            o.querySelector("[data-bundle-pants-length-name]").textContent = firstLen.textContent.trim();
          }

          var selLenEl = f.querySelector(".block-swatch.is-selected");
          if (selLenEl) {
            var selLenVal = selLenEl.textContent.trim(),
              pantsVariants = JSON.parse(swatch.dataset.variants || "[]");
            S.querySelectorAll(".block-swatch").forEach(function (el) {
              var val = el.textContent.trim(),
                avail = pantsVariants.some(function (v) { return v.option2 === selLenVal && v.option3 === val && v.available; });
              el.classList.remove("is-disabled");
              if (!avail) {
                el.classList.add("is-disabled");
                if (el.classList.contains("is-selected")) e(false);
              }
            });
          }
          a();
        }
      });
    });

    // --- Auto-select first swatches ---
    if (x.length > 0 && !document.querySelector(".bundle-top-color-swatch__container .color-swatch.is-selected")) {
      x[0].classList.add("is-selected");
      x[0].click();
    }
    if (C.length > 0 && !document.querySelector(".bundle-pants-color-swatch__container .color-swatch.is-selected")) {
      C[0].classList.add("is-selected");
      C[0].click();
    }

    // Delayed recheck in case of async DOM updates
    setTimeout(a, 100);

    // --- Dynamic swatch loading ---
    var w = async function (handle) {
      try {
        var resp = await fetch("/products/" + handle + ".js");
        return resp.ok ? await resp.json() : null;
      } catch (err) {
        return null;
      }
    };

    function L(swatch) {
      swatch.addEventListener("click", function (ev) {
        ev.preventDefault();
        var container = document.querySelector("[data-bundle-top-container]");
        if (!container) return;

        var imgEl = container.querySelector("[data-bundle-top-image]"),
          linkEl = container.querySelector("[data-bundle-top-link]"),
          titleEl = container.querySelector("[data-bundle-top-title]"),
          priceEl = container.querySelector("[data-bundle-top-price]"),
          compareEl = container.querySelector("[data-bundle-top-compare-price]"),
          colorNameEl = container.querySelector("[data-bundle-top-color-name]"),
          sizesEl = container.querySelector("[data-bundle-top-sizes]");

        document.querySelectorAll(".bundle-top-color-swatch__container .color-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
        swatch.classList.add("is-selected");
        if (imgEl && swatch.dataset.image) imgEl.src = swatch.dataset.image;
        if (linkEl) linkEl.href = swatch.getAttribute("href");
        if (titleEl && swatch.dataset.title) titleEl.textContent = swatch.dataset.title;
        if (priceEl && swatch.dataset.price) priceEl.textContent = swatch.dataset.price;
        if (colorNameEl && swatch.dataset.colorName) colorNameEl.textContent = swatch.dataset.colorName;
        if (compareEl) {
          compareEl.innerHTML = swatch.dataset.comparePrice
            ? '<span class="text-subdued line-through">' + swatch.dataset.comparePrice + "</span>"
            : "";
        }

        var prevSize = sizesEl?.querySelector(".block-swatch.is-selected")?.textContent?.trim();
        if (sizesEl && swatch.dataset.sizes) {
          var sizes = JSON.parse(swatch.dataset.sizes);
          sizesEl.innerHTML = "";
          var firstEl = null;
          sizes.forEach(function (sz) {
            var label = document.createElement("label");
            label.className = "block-swatch";
            label.textContent = sz.value;
            label.addEventListener("click", function () {
              if ("false" === sz.available) {
                label.classList.add("is-disabled");
                e(false);
              }
              sizesEl.querySelectorAll(".block-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
              label.classList.add("is-selected");
              container.querySelector("[data-bundle-top-size-name]").textContent = sz.value;
              a();
            });
            if (!firstEl) firstEl = label;
            sizesEl.appendChild(label);
          });

          var matchEl = Array.from(sizesEl.children).find(function (el) { return el.textContent.trim() === prevSize; });
          if (matchEl) {
            matchEl.classList.add("is-selected");
            container.querySelector("[data-bundle-top-size-name]").textContent = matchEl.textContent.trim();
          } else if (firstEl) {
            firstEl.classList.add("is-selected");
            container.querySelector("[data-bundle-top-size-name]").textContent = firstEl.textContent.trim();
          }

          var variants = JSON.parse(swatch.dataset.variants || "[]");
          sizesEl.querySelectorAll(".block-swatch").forEach(function (el) {
            var val = el.textContent.trim(),
              avail = variants.some(function (v) { return v.option2 === val && v.available; });
            el.classList.remove("is-disabled");
            if (!avail) {
              el.classList.add("is-disabled");
              if (el.classList.contains("is-selected")) e(false);
            }
          });
        }
        a();

        (function syncEmbroideryPopupImage() {
          var href = swatch.getAttribute('href') || '';
          var match = href.match(/\/products\/([^/?#]+)/);
          if (!match) return;
          fetch('/products/' + match[1] + '.js')
            .then(function(res) { return res.json(); })
            .then(function(prod) {
              var popup = (prod.media || []).find(function(m) {
                return (m.alt || '').toLowerCase().includes('popup:');
              });
              if (!popup) return;
              var src = popup.src.startsWith('http') ? popup.src : 'https:' + popup.src;
              document.querySelectorAll('.embroidery-image').forEach(function(el) {
                el.src = src;
                el.alt = popup.alt || '';
              });
            })
            .catch(function() {});
        })();

      });
    }

    function g(swatch) {
      swatch.addEventListener("click", function (ev) {
        ev.preventDefault();
        var container = document.querySelector("[data-bundle-pants-container]");
        if (!container) return;

        var imgEl = container.querySelector("[data-bundle-pants-image]"),
          linkEl = container.querySelector("[data-bundle-pants-link]"),
          titleEl = container.querySelector("[data-bundle-pants-title]"),
          colorNameEl = container.querySelector("[data-bundle-pants-color-name]"),
          priceEl = container.querySelector("[data-bundle-pants-price]"),
          compareEl = container.querySelector("[data-bundle-pants-compare-price]"),
          lengthsEl = container.querySelector("[data-bundle-pants-lengths]"),
          sizesEl = container.querySelector("[data-bundle-pants-sizes]");

        document.querySelectorAll(".bundle-pants-color-swatch__container .color-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
        swatch.classList.add("is-selected");
        if (imgEl && swatch.dataset.image) imgEl.src = swatch.dataset.image;
        if (linkEl) linkEl.href = swatch.getAttribute("href");
        if (titleEl && swatch.dataset.title) titleEl.textContent = swatch.dataset.title;
        if (colorNameEl && swatch.dataset.colorName) colorNameEl.textContent = swatch.dataset.colorName;
        if (priceEl && swatch.dataset.price) priceEl.textContent = swatch.dataset.price;
        if (compareEl) {
          compareEl.innerHTML = swatch.dataset.comparePrice
            ? '<span class="text-subdued line-through">' + swatch.dataset.comparePrice + "</span>"
            : "";
        }

        var prevLen = lengthsEl?.querySelector(".block-swatch.is-selected")?.textContent?.trim();

        if (lengthsEl && swatch.dataset.lengths) {
          var lengths = JSON.parse(swatch.dataset.lengths);
          lengthsEl.innerHTML = "";
          var firstLen = null;
          lengths.forEach(function (len) {
            var label = document.createElement("label");
            label.className = "block-swatch";
            label.textContent = len.value;
            if ("false" === len.available) {
              label.classList.add("is-disabled");
            } else {
              label.addEventListener("click", function () {
                lengthsEl.querySelectorAll(".block-swatch").forEach(function (el) { el.classList.remove("is-selected"); });
                label.classList.add("is-selected");
                container.querySelector("[data-bundle-pants-length-name]").textContent = len.value;
                var selLen = len.value,
                  pantsVariants = JSON.parse(swatch.dataset.variants || "[]");
                sizesEl.querySelectorAll(".block-swatch").forEach(function (el) {
                  var val = el.textContent.trim(),
                    avail = pantsVariants.some(function (v) { return v.option2 === selLen && v.option3 === val && v.available; });
                  el.classList.remove("is-disabled");
                  if (!avail) {
                    el.classList.add("is-disabled");
                    if (el.classList.contains("is-selected")) e(false);
                  }
                });
                a();
              });
              if (!firstLen) firstLen = label;
            }
            lengthsEl.appendChild(label);
          });

          var matchLen = Array.from(lengthsEl.children).find(function (el) {
            return el.textContent.trim() === prevLen && !el.classList.contains("is-disabled");
          });
          if (matchLen) {
            matchLen.classList.add("is-selected");
            container.querySelector("[data-bundle-pants-length-name]").textContent = matchLen.textContent.trim();
          } else if (firstLen) {
            firstLen.classList.add("is-selected");
            container.querySelector("[data-bundle-pants-length-name]").textContent = firstLen.textContent.trim();
          }

          var selLenEl = lengthsEl.querySelector(".block-swatch.is-selected");
          if (selLenEl) {
            var selLenVal = selLenEl.textContent.trim(),
              pantsVariants = JSON.parse(swatch.dataset.variants || "[]");
            sizesEl.querySelectorAll(".block-swatch").forEach(function (el) {
              var val = el.textContent.trim(),
                avail = pantsVariants.some(function (v) { return v.option2 === selLenVal && v.option3 === val && v.available; });
              el.classList.remove("is-disabled");
              if (!avail) {
                el.classList.add("is-disabled");
                if (el.classList.contains("is-selected")) e(false);
              }
            });
          }
          a();
        }
      });
    }

    var k = async function () {
      var topHandles = (window.bundleTopHandles || []).map(function (h) { return typeof h === "object" ? h.handle : h; }),
        pantsHandles = (window.bundlePantsHandles || []).map(function (h) { return typeof h === "object" ? h.handle : h; }),
        initialTop = new Set(window.initialTopHandles || []),
        initialPants = new Set(window.initialPantsHandles || []),
        remaining = [...new Set([...topHandles, ...pantsHandles])].filter(function (h) { return !initialTop.has(h) && !initialPants.has(h); });

      var products = await Promise.all(remaining.map(w));
      products.forEach(function (product) {
        if (!product) return;
        if (topHandles.includes(product.handle)) {
          // Add dynamic top swatch
          var wrapper = document.querySelector("[data-bundle-top-container] .bundle-top-color-swatch__container"),
            stack = wrapper?.querySelector(".h-stack");
          if (!stack) return;

          var el = document.createElement("a");
          el.className = "color-swatch color-swatch--circle color-swatch--sm";
          el.href = product.url;
          el.dataset.image = product.featured_image;
          el.dataset.title = product.title;
          el.dataset.colorName = product.variants[0]?.option1;

          var price = product.variants[0]?.price || "",
            comparePrice = product.variants[0]?.compare_at_price || "";
          el.dataset.price = _bundleFormatMoney(price / 100);
          if (comparePrice && comparePrice > price) el.dataset.comparePrice = _bundleFormatMoney(comparePrice / 100);
          el.dataset.variants = JSON.stringify(product.variants);

          var sizes = Array.from(new Set(product.variants.map(function (v) { return v.option2; }))).map(function (sz) {
            var avail = product.variants.some(function (v) { return v.option2 === sz && v.available; });
            return { value: sz, available: avail.toString() };
          });
          el.dataset.sizes = JSON.stringify(sizes);

          var colorName = product.variants[0]?.option1 || "",
            bg = window.parsedColorMap?.[colorName] || colorName;
          el.style.setProperty("--swatch-background", "linear-gradient(to right, " + bg + ", " + bg + ")");

          var sr = document.createElement("span");
          sr.className = "sr-only";
          sr.textContent = colorName;
          el.appendChild(sr);
          stack.appendChild(el);
          L(el);
        } else if (pantsHandles.includes(product.handle)) {
          // Add dynamic pants swatch
          var wrapper = document.querySelector("[data-bundle-pants-container] .bundle-pants-color-swatch__container"),
            stack = wrapper?.querySelector(".h-stack");
          if (!stack) return;

          var el = document.createElement("a");
          el.className = "color-swatch color-swatch--circle color-swatch--sm";
          el.href = product.url;
          el.dataset.image = product.featured_image;
          el.dataset.title = product.title;
          el.dataset.colorName = product.variants[0]?.option1;
          el.dataset.variants = JSON.stringify(product.variants);

          var price = product.variants[0]?.price || "",
            comparePrice = product.variants[0]?.compare_at_price || "";
          el.dataset.price = _bundleFormatMoney(price / 100);
          if (comparePrice && comparePrice > price) el.dataset.comparePrice = _bundleFormatMoney(comparePrice / 100);
          el.dataset.variants = JSON.stringify(product.variants);

          if (product.options[1]?.name === "Length") {
            var lengths = Array.from(new Set(product.variants.map(function (v) { return v.option2; }))).map(function (len) {
              var avail = product.variants.some(function (v) { return v.option2 === len && v.available; });
              return { value: len, available: avail.toString() };
            });
            el.dataset.lengths = JSON.stringify(lengths);
          }

          var sizes = Array.from(new Set(product.variants.map(function (v) { return v.option3; }))).map(function (sz) {
            var avail = product.variants.some(function (v) { return v.option3 === sz && v.available; });
            return { value: sz, available: avail.toString() };
          });
          el.dataset.sizes = JSON.stringify(sizes);

          var colorName = product.variants[0]?.option1 || "",
            bg = window.parsedColorMap?.[colorName] || colorName;
          el.style.setProperty("--swatch-background", "linear-gradient(to right, " + bg + ", " + bg + ")");

          var sr = document.createElement("span");
          sr.className = "sr-only";
          sr.textContent = colorName;
          el.appendChild(sr);
          stack.appendChild(el);
          g(el);
        }
      });
    };

    if (window.bundleTopHandles || window.bundlePantsHandles) {
      k();
    }
  } catch (err) {
    console.error("[bundle-variation] error:", err);
  }
});
